import { TextField, Box } from "@mui/material";
import { MenuItem, Select, FormControl, InputLabel } from "@mui/material";


const SimpleForm = ({ colors, handleSubmit, setFormData, formData }) => {


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };



    return (
        <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                width: 300,
                margin: "0 auto",
                padding: 2,
                backgroundColor: colors.pink[700],
                borderRadius: 2,
                boxShadow: 3,
            }}
        >
            <FormControl fullWidth>
                <InputLabel>Tipo</InputLabel>
                <Select
                    name="tipo"  // ✅ Add this to match formData key
                    value={formData.tipo || ""} // ✅ Ensure it has a default value
                    onChange={handleChange}
                    label="Tipo"
                >
                    <MenuItem value="Voucher">Voucher</MenuItem>
                    <MenuItem value="Saldo Passado">Saldo Passado</MenuItem>
                </Select>
            </FormControl>
            <TextField
                label="Valor"
                name="value"
                value={formData.value}
                onChange={handleChange}
                type="number"
                variant="outlined"
                fullWidth
                required
                inputProps={{
                    step: "1", // Allows decimals with two precision
                    
                }}
                sx={{
                    "& .MuiOutlinedInput-root": {
                        height: '50px',
                        "&:hover fieldset": {
                            borderColor: "whitesmoke", // Change border color on hover
                        },
                        "&.Mui-focused fieldset": {
                            borderColor: "whitesmoke", // Change border color when focused
                        },
                    },
                    "& .MuiInputLabel-root": {
                        color: "grey", // Default label color
                        "&:hover": {
                            color: "whitesmoke", // Label color on hover
                        },
                        "&.Mui-focused": {
                            color: "whitesmoke", // Label color when focused
                        },
                    },
                }}
            />
        </Box>
    );
};

export default SimpleForm;